import { GUEST_EMAIL } from "@/constants/user";

class AuthHelpers {
  isGuestLoggedIn() {
    return localStorage.email === GUEST_EMAIL;
  }
}

export default new AuthHelpers();
